import { DataUploadSection } from "../components/DataUploadSection";
import { IHMAPricingForm } from "../components/IHMAPricingForm";

interface ExternalDataUploadTabProps {
  activeTab: string;
}
const ExternalDataUploadTab: React.FC<ExternalDataUploadTabProps> = ({ activeTab }) => {
  return (
    <div className="tab trend-explorer-tab flex flex-col gap-10 px-2 pt-8 md:px-8 md:pt-12 lg:pt-14">
      <DataUploadSection activeTab={activeTab} />
      <IHMAPricingForm />
    </div>
  );
};

export default ExternalDataUploadTab;